(function(){
    'use strict';

    angular
        .module('completeAir')

        .factory('airCrewService', airCrewService);

    airCrewService.$inject = ['$http', 'CONFIG', 'messageService'];


    function airCrewService($http, CONFIG, messageService) {

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/crew/';

        var service = {
            getAirCrews: getAirCrews,
            getPageAirCrews: getPageAirCrews,
            getAirCrewById: getAirCrewById,
            saveAirCrew: saveAirCrew,
            saveAddAirCrew: saveAddAirCrew,
            updateAirCrew: updateAirCrew,
            deleteAirCrew: deleteAirCrew,
            thereIdentityNumber: thereIdentityNumber,
            thereLicense: thereLicense
        };
        return service;

        function getAirCrews(){
            return $http.get(urlBase + "?commandCrew=true&active=true")
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response){
                return (response.data._embedded) ? response.data._embedded.aircrews : [];
            }
            function getFailed(){
                messageService.findAllError('');
            }
        }

        function getPageAirCrews(page, size){
            return $http.get(urlBase + 'page?page=' + page + '&size=' + size + '&commandCrew=true&active=true')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('airCrews')
                });
        }

        function saveAirCrew(airCrew){
            return $http.post(urlBase + "?commandCrew=true&active=true", airCrew)
                .then(saveComplete)
                .catch(getFailed);

            function saveComplete(){
                messageService.register('airCrews');
            }
            function getFailed(){
                messageService.registerError('airCrews');
            }
        }

        function saveAddAirCrew(airCrew){
            return $http.post(urlBase + "?commandCrew=true&active=true", airCrew)
            .then(function (response) {
                messageService.register('');
                return response;
            })
            .catch(function () {
                messageService.registerError('');
            });
        }

        function getAirCrewById (id){
            return $http.get(urlBase + id)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response){
                return (response.data) ? response.data : [];
            }
            function getFailed(){
                messageService.findAllError('airCrews');
            }
        }

        function updateAirCrew(id, airCrew){
            return $http.put(urlBase + id, airCrew)
                .then(function(response){
                    messageService.registerUpdate('airCrews')
                    return response;
                })
                .catch(function(error){
                    messageService.findAllError('airCrews');
                });
        }

        function deleteAirCrew(id) {
            return $http.delete(urlBase+id)
                .then(deleteComplete)
                .catch(getFailed);

            function deleteComplete(){
                messageService.register('airCrews');
            }
            function getFailed(){
                messageService.registerError('airCrews');
            }
        }

        function thereIdentityNumber (nroIdentity){
            return $http.get(urlBase + "thereIdentityNumber/" + nroIdentity, {headers: {'Loading-Overlay': false}})
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response){
                return response;//(response.data) ? response.data : [];
            }
            function getFailed(){
                messageService.findAError('');
            }
        }

        function thereLicense (nroIdentity){
            return $http.get(urlBase + "thereLicense/" + nroIdentity, {headers: {'Loading-Overlay': false}})
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response){
                return response;//(response.data) ? response.data : [];
            }
            function getFailed(){
                messageService.findAError('');
            }
        }
    }

})();

